/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/fragments-delivery-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/fragments-delivery-api-client";
import type { FragmentsDeliveryAPIStationConfigClientGetConfigQueryResponse, FragmentsDeliveryAPIStationConfigClientGetConfigPathParams } from "../models/FragmentsDeliveryAPIStationConfigClientGetConfig";

function getFragmentsDeliveryAPIStationConfigClientGetConfigUrl(stationId: FragmentsDeliveryAPIStationConfigClientGetConfigPathParams["stationId"]) {
  const res = { method: 'GET', url: `/station-config/${stationId}` as const }  
  return res
}

/**
 * @summary Get Station config (client access)
 * {@link /station-config/:stationId}
 */
export async function fragmentsDeliveryAPIStationConfigClientGetConfig(stationId: FragmentsDeliveryAPIStationConfigClientGetConfigPathParams["stationId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<FragmentsDeliveryAPIStationConfigClientGetConfigQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getFragmentsDeliveryAPIStationConfigClientGetConfigUrl(stationId).url.toString(), ... requestConfig })  
  return res.data
}